import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Backdrop, CircularProgress, Grow, Modal } from '@material-ui/core';
import * as Utils from '../../commons/utils/Utils';
import SolicitudAdjuntosLista from './SolicitudAdjuntosLista.jsx';

const SolicitudAdjuntosModal = ({ solicitud, onClose }) => {
	const [adjuntos, setAdjuntos] = useState([]);
	const [cargando, setCargando] = useState(false);
	const [error, setError] = useState(false);

	useEffect(() => {
		if (!solicitud) return undefined;

		let vigente = true;
		setCargando(true);
		setError(false);
		setAdjuntos([]);

		Utils.getData('/solicitudes/' + solicitud.id + '/adjuntos')
			.then((data) => {
				if (vigente) setAdjuntos(data || []);
			})
			.catch(() => {
				if (vigente) setError(true);
			})
			.finally(() => {
				if (vigente) setCargando(false);
			});

		return () => {
			vigente = false;
		};
	}, [solicitud && solicitud.id]);

	if (!solicitud) return null;

	return (
		<Modal open={!!solicitud} onClose={onClose} closeAfterTransition BackdropComponent={Backdrop} BackdropProps={{ timeout: 300 }}>
			<Grow in={!!solicitud}>
				<div tabIndex="-1" role="dialog">
					<div className="modal-lg modal-dialog" role="document">
						<div className="modal-content">
							<div className="modal-header bg-fleet">
								<h4 className="modal-title text-white mb-0">
									<i className="la la-paperclip align-middle icon-modal-title"></i>{' '}
									<FormattedMessage id="solicitudAdjuntosModal.titulo" defaultMessage="Adjuntos de la solicitud {numero}" values={{ numero: solicitud.numero }} />
								</h4>
								<button type="button" className="close" aria-label="Close" onClick={onClose}>
									<span aria-hidden="true">&times;</span>
								</button>
							</div>
							<div className="modal-body modal-grey modal-mh ovf-x-hidden">
								{cargando && (
									<div className="text-center p-2">
										<CircularProgress />
									</div>
								)}
								{!cargando && error && (
									<div className="text-danger">
										<FormattedMessage id="solicitudAdjuntosModal.error" defaultMessage="No se pudieron cargar los adjuntos." />
									</div>
								)}
								{!cargando && !error && adjuntos.length === 0 && (
									<div>
										<FormattedMessage id="solicitudAdjuntosModal.vacio" defaultMessage="La solicitud no tiene adjuntos." />
									</div>
								)}
								{!cargando && !error && adjuntos.length > 0 && (
									<SolicitudAdjuntosLista adjuntos={adjuntos} />
								)}
							</div>
							<div className="modal-footer modal-grey">
								<button type="button" className="btn btn-default btn-fleet" onClick={onClose}>
									<FormattedMessage id="solicitudAdjuntosModal.ok" defaultMessage="Ok" />
								</button>
							</div>
						</div>
					</div>
				</div>
			</Grow>
		</Modal>
	);
};

export default SolicitudAdjuntosModal;
